/** Nội dung watermark học liệu của người đang đăng nhập (plan 2026-10-03). */
import { useEffect, useState } from "react";
import dayjs from "dayjs";
import { useAuthStore } from "@/stores/auth";

/** Các dòng watermark của người đang đăng nhập; null khi tính năng tắt. */
export function useWatermarkLines(): string[] | null {
  const user = useAuthStore((s) => s.user);
  const enabled = !!user?.feature_flags?.content_watermark;
  const [now, setNow] = useState(() => dayjs());

  useEffect(() => {
    if (!enabled) return;
    const timer = window.setInterval(() => setNow(dayjs()), 60_000);
    return () => window.clearInterval(timer);
  }, [enabled]);

  if (!enabled || !user) return null;
  const name = `${user.first_name ?? ""} ${user.last_name ?? ""}`.trim() || user.email;
  const id = user.student_id || user.email;
  return [name === id ? name : `${name} · ${id}`, now.format("DD/MM/YYYY HH:mm")];
}
